import type { ComponentPropsWithRef, ReactNode } from "react";
import { cn } from "../../lib/cn";

export interface SafeAreaViewProps extends ComponentPropsWithRef<"div"> {
  /** Bords à protéger avec les insets natifs ("top", "bottom", "left", "right", "all" ou combinaison). */
  edges?: ("top" | "bottom" | "left" | "right")[];
  /** Rend le conteneur en hauteur dynamique plein écran (`min-h-dvh`). */
  fullHeight?: boolean;
  children?: ReactNode;
}

/**
 * Conteneur de zone de sécurité mobile (Safe Area Insets) cross-plateforme SOTA.
 * Protège automatiquement le contenu des encoches (notch), barre d'accueil iOS et barre de navigation Android.
 */
export function SafeAreaView({
  className,
  edges = ["top", "bottom", "left", "right"],
  fullHeight = false,
  children,
  ...props
}: SafeAreaViewProps) {
  const hasTop = edges.includes("top");
  const hasBottom = edges.includes("bottom");
  const hasLeft = edges.includes("left");
  const hasRight = edges.includes("right");

  return (
    <div
      className={cn(
        fullHeight && "min-h-dvh",
        hasTop && "pt-safe",
        hasBottom && "pb-safe",
        hasLeft && "pl-safe",
        hasRight && "pr-safe",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function SafeAreaProvider({ children }: { children: ReactNode }) {
  return <div className="min-h-dvh w-full">{children}</div>;
}
